// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-backgroundDP {
  --background: url("/assets/img/digitalPlace/pattern_no_logo.png") no-repeat center center / cover !important;
}

.menu-background {
  --background: url("/assets/img/background-menu.svg") no-repeat bottom center / contain !important;
}

ion-icon {
  margin-right: 10px;
}

ion-menu ion-content {
  --background: var(--ion-item-background, var(--ion-background-color, #fff));
}

ion-menu.md ion-content {
  --padding-start: 8px;
  --padding-end: 8px;
  --padding-top: 20px;
  --padding-bottom: 20px;
}

ion-menu.md ion-list {
  padding: 0;
}

ion-menu.md ion-note {
  margin-bottom: 30px;
}

ion-menu.md ion-list-header,
ion-menu.md ion-note {
  padding-left: 10px;
}

ion-menu.md ion-list#inbox-list ion-list-header {
  font-size: 22px;
  font-weight: 500;
  min-height: 20px;
}

ion-menu.md ion-list#labels-list ion-list-header {
  font-size: 16px;
  margin-bottom: 18px;
  color: var(--ion-color-medium);
  min-height: 26px;
}

ion-menu.md ion-item {
  --padding-start: 10px;
  --padding-end: 10px;
  border-radius: 10px;
}

ion-menu.md ion-item.selected {
  --background: rgba(var(--ion-color-secondary-rgb), 0.14);
}

ion-menu.md ion-item.selected ion-icon {
  color: var(--ion-color-secondary);
}

ion-menu.md ion-item ion-icon {
  color: var(--ion-color-medium-shade);
}

ion-menu.ios ion-content {
  --padding-bottom: 20px;
}

ion-menu.ios ion-list {
  padding: 20px 0 0 0;
}

ion-menu.ios ion-note {
  line-height: 24px;
  margin-bottom: 20px;
}

ion-menu.ios ion-item {
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 50px;
}

ion-menu.ios ion-item.selected ion-icon {
  color: var(--ion-color-secondary);
}

ion-menu.ios ion-item ion-icon {
  font-size: 23 px;
  color: var(--ion-color-medium);
}

ion-menu.ios ion-list#labels-list ion-list-header {
  margin-bottom: 8px;
}

ion-menu.ios ion-list-header,
ion-menu.ios ion-note {
  padding-left: 16px;
  padding-right: 16px;
}

ion-menu.ios ion-note {
  margin-bottom: 8px;
}

ion-note {
  display: inline-block;
  font-size: 16px;
  color: var(--ion-color-dark-shade);
}

ion-item.selected {
  --color: var(--ion-color-secondary);
}

ion-icon {
  margin-right: 10px;
}

ion-item {
  padding: 3px 10px 3px 5px;
  height: 35px;
  display: flex;
  align-items: center;
}
ion-item::part(native) {
  min-width: 100% !important;
}
ion-item ion-label {
  font-weight: 300;
  color: var(--ion-color-medium-shade);
  font-size: 14px;
}

ion-content {
  padding: 0 !important;
  --padding-end: 0 !important;
  --padding-start: 0 !important;
  --padding-top: 0 !important;
  --padding-bottom: 0 !important;
  --overflow: hidden;
}

ion-list {
  height: calc(100vh - 254px);
  overflow-y: auto;
}

ion-text {
  display: block;
}

ion-label {
  color: var(--ion-color-medium) !important;
  text-overflow: initial !important;
}

.content-image-logo {
  height: 130px;
  width: 100%;
  background-image: url("/assets/img/BIGStudio_italycolor.png");
  background-repeat: round;
}
.content-image-logo ion-icon {
  font-size: 50px;
}

.content-xmas {
  height: 130px;
  width: 100%;
  background-image: url("/assets/img/xmas.png");
  background-repeat: round;
  margin-bottom: 20px;
}
.content-xmas ion-icon {
  font-size: 50px;
}

.container-powered-by-version {
  position: relative;
  bottom: 0;
  left: 0;
  width: 100%;
  font-size: 11px;
  text-align: center;
  padding: 5px 0;
  color: var(--ion-color-medium-shade);
  margin: 0 auto;
}
.container-powered-by-version.with-version {
  bottom: calc(15px + var(--ion-safe-area-bottom));
}

.container-menu-data {
  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);
  padding: 0 15px 20px;
}

.container-menu-access-control {
  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);
  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);
  padding: 10px 0;
  margin: 10px 0;
}

.container-user-row-field {
  padding-left: 0;
  padding-right: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.container-user-row-field:not(:first-child) {
  margin-top: 10px;
}

.container-text-user-data {
  font-size: 15px;
}

.menu-connection-icon.connected {
  color: var(--ion-color-primary, #0cd1e8) !important;
}
.menu-connection-icon.connecting {
  color: var(--ion-color-warning, #ffce00) !important;
}
.menu-connection-icon.no-connection {
  animation: blink 2s infinite;
}

.menu-user-data-icon {
  font-size: 24px;
  vertical-align: middle;
}

.container-user-data {
  padding: 10px 15px;
}

.menu-subitem-expanded {
  height: 35px;
  --padding-start: 33px !important;
  transition: 0.2s linear;
}

.menu-subitem-expanded-add {
  height: 35px;
  --padding-start: 30px !important;
  transition: 0.2s linear;
}

.menu-item-collapsed {
  height: 0px !important;
  padding: 0px !important;
}

.container-menu-content-real {
  border-bottom: thin solid rgba(var(--ion-color-medium-rgb), 0.25);
  border-top: thin solid rgba(var(--ion-color-medium-rgb), 0.25);
  padding: 10px 0;
  margin-bottom: 10px;
}
.container-menu-content-real > ion-item {
  --padding-start: 0 !important;
  --padding-end: 0 !important;
}

.menu-item-end {
  --padding-start: 0 !important;
  --padding-end: 0 !important;
}

.container-menu-content {
  height: calc(100vh - 27px);
}

.container-real-menu {
  padding: 0 10px;
}

@keyframes blink {
  0% {
    color: #ffffff;
  }
  25% {
    color: var(--ion-color-danger);
  }
  75% {
    color: var(--ion-color-danger);
  }
  100% {
    color: #ffffff;
  }
}
/* The menu fills the height of its panel (the version stays under it): its entries scroll inside
 * (see menu-web-digital-place) instead of the whole panel */
ion-content.menu-background::part(scroll) {
  display: flex;
  flex-direction: column;
}

app-menu-web-digital-place {
  flex: 1;
  min-height: 0;
}

.container-powered-by-version {
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/general components/menu-web/menu-web.component.scss","webpack://./src/components/general%20components/menu-web/menu-web.component.scss"],"names":[],"mappings":"AAAA;EACE,4GAAA;ACCF;;ADEA;EACE,iGAAA;ACCF;;ADGA;EACE,kBAAA;ACAF;;ADGA;EACE,2EAAA;ACAF;;ADGA;EACE,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;ACAF;;ADGA;EACE,UAAA;ACAF;;ADGA;EACE,mBAAA;ACAF;;ADGA;;EAEE,kBAAA;ACAF;;ADGA;EACE,eAAA;EACA,gBAAA;EAEA,gBAAA;ACDF;;ADIA;EACE,eAAA;EAEA,mBAAA;EAEA,8BAAA;EAEA,gBAAA;ACJF;;ADOA;EACE,qBAAA;EACA,mBAAA;EACA,mBAAA;ACJF;;ADOA;EACE,wDAAA;ACJF;;ADOA;EACE,iCAAA;ACJF;;ADOA;EACE,oCAAA;ACJF;;ADOA;EACE,sBAAA;ACJF;;ADOA;EACE,mBAAA;ACJF;;ADOA;EACE,iBAAA;EACA,mBAAA;ACJF;;ADOA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;ACJF;;ADOA;EACE,iCAAA;ACJF;;ADOA;EACE,gBAAA;EACA,8BAAA;ACJF;;ADOA;EACE,kBAAA;ACJF;;ADOA;;EAEE,kBAAA;EACA,mBAAA;ACJF;;ADOA;EACE,kBAAA;ACJF;;ADOA;EACE,qBAAA;EACA,eAAA;EAEA,kCAAA;ACLF;;ADQA;EACE,mCAAA;ACLF;;ADQA;EACE,kBAAA;ACLF;;ADQA;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;ACLF;ADOE;EACE,0BAAA;ACLJ;ADQE;EACE,gBAAA;EACA,oCAAA;EACA,eAAA;ACNJ;;ADUA;EACE,qBAAA;EACA,2BAAA;EACA,6BAAA;EACA,2BAAA;EAEA,8BAAA;EACA,kBAAA;ACRF;;ADWA;EACE,2BAAA;EACA,gBAAA;ACRF;;ADWA;EACE,cAAA;ACRF;;ADWA;EACE,yCAAA;EACA,iCAAA;ACRF;;ADWA;EACE,aAAA;EACA,WAAA;EACA,6DAAA;EACA,wBAAA;ACRF;ADUE;EACE,eAAA;ACRJ;;ADYA;EACE,aAAA;EACA,WAAA;EACA,6CAAA;EACA,wBAAA;EACA,mBAAA;ACTF;ADWE;EACE,eAAA;ACTJ;;ADaA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EAEA,oCAAA;EACA,cAAA;ACXF;ADaE;EACE,gDAAA;ACXJ;;ADeA;EACE,gEAAA;EACA,oBAAA;ACZF;;ADeA;EACE,gEAAA;EACA,6DAAA;EACA,eAAA;EACA,cAAA;ACZF;;ADeA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;ACZF;ADcE;EACE,gBAAA;ACZJ;;ADgBA;EACE,eAAA;ACbF;;ADiBE;EACE,mDAAA;ACdJ;ADiBE;EACE,mDAAA;ACfJ;ADkBE;EACE,4BAAA;AChBJ;;ADoBA;EACE,eAAA;EACA,sBAAA;ACjBF;;ADoBA;EACE,kBAAA;ACjBF;;ADoBA;EACE,YAAA;EACA,gCAAA;EACA,uBAAA;ACjBF;;ADoBA;EACE,YAAA;EACA,gCAAA;EACA,uBAAA;ACjBF;;ADoBA;EACE,sBAAA;EACA,uBAAA;ACjBF;;ADoBA;EACE,iEAAA;EACA,8DAAA;EACA,eAAA;EACA,mBAAA;ACjBF;ADmBE;EACE,6BAAA;EACA,2BAAA;ACjBJ;;ADqBA;EACE,6BAAA;EACA,2BAAA;AClBF;;ADqBA;EACE,0BAAA;AClBF;;ADqBA;EACE,eAAA;AClBF;;ADqBA;EACE;IACE,cAAA;EClBF;EDqBA;IACE,8BAAA;ECnBF;EDsBA;IACE,8BAAA;ECpBF;EDuBA;IACE,cAAA;ECrBF;AACF;ADwBA;4DAAA;AAEA;EACE,aAAA;EACA,sBAAA;ACtBF;;ADyBA;EACE,OAAA;EACA,aAAA;ACtBF;;ADyBA;EACE,cAAA;ACtBF","sourcesContent":[".custom-backgroundDP {\n  --background: url(\"/assets/img/digitalPlace/pattern_no_logo.png\") no-repeat center center / cover !important;\n}\n\n.menu-background {\n  --background: url(\"/assets/img/background-menu.svg\") no-repeat bottom center / contain !important;\n\n}\n\nion-icon {\n  margin-right: 10px;\n}\n\nion-menu ion-content {\n  --background: var(--ion-item-background, var(--ion-background-color, #fff));\n}\n\nion-menu.md ion-content {\n  --padding-start: 8px;\n  --padding-end: 8px;\n  --padding-top: 20px;\n  --padding-bottom: 20px;\n}\n\nion-menu.md ion-list {\n  padding: 0;\n}\n\nion-menu.md ion-note {\n  margin-bottom: 30px;\n}\n\nion-menu.md ion-list-header,\nion-menu.md ion-note {\n  padding-left: 10px;\n}\n\nion-menu.md ion-list#inbox-list ion-list-header {\n  font-size: 22px;\n  font-weight: 500;\n\n  min-height: 20px;\n}\n\nion-menu.md ion-list#labels-list ion-list-header {\n  font-size: 16px;\n\n  margin-bottom: 18px;\n\n  color: var(--ion-color-medium);\n\n  min-height: 26px;\n}\n\nion-menu.md ion-item {\n  --padding-start: 10px;\n  --padding-end: 10px;\n  border-radius: 10px;\n}\n\nion-menu.md ion-item.selected {\n  --background: rgba(var(--ion-color-secondary-rgb), 0.14);\n}\n\nion-menu.md ion-item.selected ion-icon {\n  color: var(--ion-color-secondary);\n}\n\nion-menu.md ion-item ion-icon {\n  color: var(--ion-color-medium-shade);\n}\n\nion-menu.ios ion-content {\n  --padding-bottom: 20px;\n}\n\nion-menu.ios ion-list {\n  padding: 20px 0 0 0;\n}\n\nion-menu.ios ion-note {\n  line-height: 24px;\n  margin-bottom: 20px;\n}\n\nion-menu.ios ion-item {\n  --padding-start: 16px;\n  --padding-end: 16px;\n  --min-height: 50px;\n}\n\nion-menu.ios ion-item.selected ion-icon {\n  color: var(--ion-color-secondary);\n}\n\nion-menu.ios ion-item ion-icon {\n  font-size: 23 px;\n  color: var(--ion-color-medium);\n}\n\nion-menu.ios ion-list#labels-list ion-list-header {\n  margin-bottom: 8px;\n}\n\nion-menu.ios ion-list-header,\nion-menu.ios ion-note {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\nion-menu.ios ion-note {\n  margin-bottom: 8px;\n}\n\nion-note {\n  display: inline-block;\n  font-size: 16px;\n\n  color: var(--ion-color-dark-shade);\n}\n\nion-item.selected {\n  --color: var(--ion-color-secondary);\n}\n\nion-icon {\n  margin-right: 10px;\n}\n\nion-item {\n  padding: 3px 10px 3px 5px;\n  height: 35px;\n  display: flex;\n  align-items: center;\n\n  &::part(native) {\n    min-width: 100% !important;\n  }\n\n  ion-label {\n    font-weight: 300;\n    color: var(--ion-color-medium-shade);\n    font-size: 14px;\n  }\n}\n\nion-content {\n  padding: 0 !important;\n  --padding-end: 0 !important;\n  --padding-start: 0 !important;\n  --padding-top: 0 !important;\n\n  --padding-bottom: 0 !important;\n  --overflow: hidden;\n}\n\nion-list {\n  height: calc(100vh - 254px);\n  overflow-y: auto;\n}\n\nion-text {\n  display: block;\n}\n\nion-label {\n  color: var(--ion-color-medium) !important;\n  text-overflow: initial !important;\n}\n\n.content-image-logo {\n  height: 130px;\n  width: 100%;\n  background-image: url(\"/assets/img/BIGStudio_italycolor.png\");\n  background-repeat: round;\n\n  ion-icon {\n    font-size: 50px;\n  }\n}\n\n.content-xmas {\n  height: 130px;\n  width: 100%;\n  background-image: url(\"/assets/img/xmas.png\");\n  background-repeat: round;\n  margin-bottom: 20px;\n\n  ion-icon {\n    font-size: 50px;\n  }\n}\n\n.container-powered-by-version {\n  position: relative;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  font-size: 11px;\n  text-align: center;\n  padding: 5px 0;\n\n  color: var(--ion-color-medium-shade);\n  margin: 0 auto;\n\n  &.with-version {\n    bottom: calc(15px + var(--ion-safe-area-bottom));\n  }\n}\n\n.container-menu-data {\n  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);\n  padding: 0 15px 20px;\n}\n\n.container-menu-access-control {\n  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);\n  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);\n  padding: 10px 0;\n  margin: 10px 0;\n}\n\n.container-user-row-field {\n  padding-left: 0;\n  padding-right: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n\n  &:not(:first-child) {\n    margin-top: 10px;\n  }\n}\n\n.container-text-user-data {\n  font-size: 15px;\n}\n\n.menu-connection-icon {\n  &.connected {\n    color: var(--ion-color-primary, #0cd1e8) !important; //MODIF.\n  }\n\n  &.connecting {\n    color: var(--ion-color-warning, #ffce00) !important;\n  }\n\n  &.no-connection {\n    animation: blink 2s infinite;\n  }\n}\n\n.menu-user-data-icon {\n  font-size: 24px;\n  vertical-align: middle;\n}\n\n.container-user-data {\n  padding: 10px 15px;\n}\n\n.menu-subitem-expanded {\n  height: 35px;\n  --padding-start: 33px !important;\n  transition: 0.2s linear;\n}\n\n.menu-subitem-expanded-add {\n  height: 35px;\n  --padding-start: 30px !important;\n  transition: 0.2s linear;\n}\n\n.menu-item-collapsed {\n  height: 0px !important;\n  padding: 0px !important;\n}\n\n.container-menu-content-real {\n  border-bottom: thin solid rgba(var(--ion-color-medium-rgb), 0.25);\n  border-top: thin solid rgba(var(--ion-color-medium-rgb), 0.25);\n  padding: 10px 0;\n  margin-bottom: 10px;\n\n  &>ion-item {\n    --padding-start: 0 !important;\n    --padding-end: 0 !important;\n  }\n}\n\n.menu-item-end {\n  --padding-start: 0 !important;\n  --padding-end: 0 !important;\n}\n\n.container-menu-content {\n  height: calc(100vh - 27px);\n}\n\n.container-real-menu {\n  padding: 0 10px;\n}\n\n@keyframes blink {\n  0% {\n    color: #ffffff;\n  }\n\n  25% {\n    color: var(--ion-color-danger);\n  }\n\n  75% {\n    color: var(--ion-color-danger);\n  }\n\n  100% {\n    color: #ffffff;\n  }\n}\n\n/* The menu fills the height of its panel (the version stays under it): its entries scroll inside\n * (see menu-web-digital-place) instead of the whole panel */\nion-content.menu-background::part(scroll) {\n  display: flex;\n  flex-direction: column;\n}\n\napp-menu-web-digital-place {\n  flex: 1;\n  min-height: 0;\n}\n\n.container-powered-by-version {\n  flex-shrink: 0;\n}\n",".custom-backgroundDP {\n  --background: url(\"/assets/img/digitalPlace/pattern_no_logo.png\") no-repeat center center / cover !important;\n}\n\n.menu-background {\n  --background: url(\"/assets/img/background-menu.svg\") no-repeat bottom center / contain !important;\n}\n\nion-icon {\n  margin-right: 10px;\n}\n\nion-menu ion-content {\n  --background: var(--ion-item-background, var(--ion-background-color, #fff));\n}\n\nion-menu.md ion-content {\n  --padding-start: 8px;\n  --padding-end: 8px;\n  --padding-top: 20px;\n  --padding-bottom: 20px;\n}\n\nion-menu.md ion-list {\n  padding: 0;\n}\n\nion-menu.md ion-note {\n  margin-bottom: 30px;\n}\n\nion-menu.md ion-list-header,\nion-menu.md ion-note {\n  padding-left: 10px;\n}\n\nion-menu.md ion-list#inbox-list ion-list-header {\n  font-size: 22px;\n  font-weight: 500;\n  min-height: 20px;\n}\n\nion-menu.md ion-list#labels-list ion-list-header {\n  font-size: 16px;\n  margin-bottom: 18px;\n  color: var(--ion-color-medium);\n  min-height: 26px;\n}\n\nion-menu.md ion-item {\n  --padding-start: 10px;\n  --padding-end: 10px;\n  border-radius: 10px;\n}\n\nion-menu.md ion-item.selected {\n  --background: rgba(var(--ion-color-secondary-rgb), 0.14);\n}\n\nion-menu.md ion-item.selected ion-icon {\n  color: var(--ion-color-secondary);\n}\n\nion-menu.md ion-item ion-icon {\n  color: var(--ion-color-medium-shade);\n}\n\nion-menu.ios ion-content {\n  --padding-bottom: 20px;\n}\n\nion-menu.ios ion-list {\n  padding: 20px 0 0 0;\n}\n\nion-menu.ios ion-note {\n  line-height: 24px;\n  margin-bottom: 20px;\n}\n\nion-menu.ios ion-item {\n  --padding-start: 16px;\n  --padding-end: 16px;\n  --min-height: 50px;\n}\n\nion-menu.ios ion-item.selected ion-icon {\n  color: var(--ion-color-secondary);\n}\n\nion-menu.ios ion-item ion-icon {\n  font-size: 23 px;\n  color: var(--ion-color-medium);\n}\n\nion-menu.ios ion-list#labels-list ion-list-header {\n  margin-bottom: 8px;\n}\n\nion-menu.ios ion-list-header,\nion-menu.ios ion-note {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\nion-menu.ios ion-note {\n  margin-bottom: 8px;\n}\n\nion-note {\n  display: inline-block;\n  font-size: 16px;\n  color: var(--ion-color-dark-shade);\n}\n\nion-item.selected {\n  --color: var(--ion-color-secondary);\n}\n\nion-icon {\n  margin-right: 10px;\n}\n\nion-item {\n  padding: 3px 10px 3px 5px;\n  height: 35px;\n  display: flex;\n  align-items: center;\n}\nion-item::part(native) {\n  min-width: 100% !important;\n}\nion-item ion-label {\n  font-weight: 300;\n  color: var(--ion-color-medium-shade);\n  font-size: 14px;\n}\n\nion-content {\n  padding: 0 !important;\n  --padding-end: 0 !important;\n  --padding-start: 0 !important;\n  --padding-top: 0 !important;\n  --padding-bottom: 0 !important;\n  --overflow: hidden;\n}\n\nion-list {\n  height: calc(100vh - 254px);\n  overflow-y: auto;\n}\n\nion-text {\n  display: block;\n}\n\nion-label {\n  color: var(--ion-color-medium) !important;\n  text-overflow: initial !important;\n}\n\n.content-image-logo {\n  height: 130px;\n  width: 100%;\n  background-image: url(\"/assets/img/BIGStudio_italycolor.png\");\n  background-repeat: round;\n}\n.content-image-logo ion-icon {\n  font-size: 50px;\n}\n\n.content-xmas {\n  height: 130px;\n  width: 100%;\n  background-image: url(\"/assets/img/xmas.png\");\n  background-repeat: round;\n  margin-bottom: 20px;\n}\n.content-xmas ion-icon {\n  font-size: 50px;\n}\n\n.container-powered-by-version {\n  position: relative;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  font-size: 11px;\n  text-align: center;\n  padding: 5px 0;\n  color: var(--ion-color-medium-shade);\n  margin: 0 auto;\n}\n.container-powered-by-version.with-version {\n  bottom: calc(15px + var(--ion-safe-area-bottom));\n}\n\n.container-menu-data {\n  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);\n  padding: 0 15px 20px;\n}\n\n.container-menu-access-control {\n  border-bottom: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);\n  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);\n  padding: 10px 0;\n  margin: 10px 0;\n}\n\n.container-user-row-field {\n  padding-left: 0;\n  padding-right: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n}\n.container-user-row-field:not(:first-child) {\n  margin-top: 10px;\n}\n\n.container-text-user-data {\n  font-size: 15px;\n}\n\n.menu-connection-icon.connected {\n  color: var(--ion-color-primary, #0cd1e8) !important;\n}\n.menu-connection-icon.connecting {\n  color: var(--ion-color-warning, #ffce00) !important;\n}\n.menu-connection-icon.no-connection {\n  animation: blink 2s infinite;\n}\n\n.menu-user-data-icon {\n  font-size: 24px;\n  vertical-align: middle;\n}\n\n.container-user-data {\n  padding: 10px 15px;\n}\n\n.menu-subitem-expanded {\n  height: 35px;\n  --padding-start: 33px !important;\n  transition: 0.2s linear;\n}\n\n.menu-subitem-expanded-add {\n  height: 35px;\n  --padding-start: 30px !important;\n  transition: 0.2s linear;\n}\n\n.menu-item-collapsed {\n  height: 0px !important;\n  padding: 0px !important;\n}\n\n.container-menu-content-real {\n  border-bottom: thin solid rgba(var(--ion-color-medium-rgb), 0.25);\n  border-top: thin solid rgba(var(--ion-color-medium-rgb), 0.25);\n  padding: 10px 0;\n  margin-bottom: 10px;\n}\n.container-menu-content-real > ion-item {\n  --padding-start: 0 !important;\n  --padding-end: 0 !important;\n}\n\n.menu-item-end {\n  --padding-start: 0 !important;\n  --padding-end: 0 !important;\n}\n\n.container-menu-content {\n  height: calc(100vh - 27px);\n}\n\n.container-real-menu {\n  padding: 0 10px;\n}\n\n@keyframes blink {\n  0% {\n    color: #ffffff;\n  }\n  25% {\n    color: var(--ion-color-danger);\n  }\n  75% {\n    color: var(--ion-color-danger);\n  }\n  100% {\n    color: #ffffff;\n  }\n}\n/* The menu fills the height of its panel (the version stays under it): its entries scroll inside\n * (see menu-web-digital-place) instead of the whole panel */\nion-content.menu-background::part(scroll) {\n  display: flex;\n  flex-direction: column;\n}\n\napp-menu-web-digital-place {\n  flex: 1;\n  min-height: 0;\n}\n\n.container-powered-by-version {\n  flex-shrink: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
